/* eslint-disable react/prop-types */ // TODO: add props
import { useState } from 'react';
import { Collapse, Icon } from 'edrolo-style-guide';
import CollabModal from '../CollabModal';
import { Activity } from 'core/components/Activity';
import s from './styles.scss';

export const StudentResponse = ({
  activity,
  activityResponse,
  student,
  students,
  updateCollaborators,
  collabModalOptions,
  analyticsPayload = {},
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const { enable_collaborators } = activity;
  const { collaborators } = activityResponse;
  const collaboratorNames = collaborators.map((profileId) => {
    const targetStudents = students.filter((s) => s.profile_id === profileId);
    return targetStudents.length ? targetStudents[0].display_name : '';
  });

  return (
    <Collapse isOpen={isOpen}>
      <Collapse.Header onClick={() => setIsOpen(!isOpen)}>
        <div className={s.header}>
          <div>
            <span className={s.primaryResponderName}>
              {student?.display_name || 'No activity owner'}
            </span>
            {enable_collaborators && collaboratorNames && ', '}
            {enable_collaborators && collaboratorNames.join(', ')}
          </div>
          <Icon name={isOpen ? 'caret-up' : 'caret-down'} />
        </div>
      </Collapse.Header>
      <Collapse.Body>
        <div className={s.body}>
          {enable_collaborators && (
            <>
              <button className={s.link} onClick={() => setModalOpen(true)}>
                Edit collaborators
              </button>
              <CollabModal
                isOpen={modalOpen}
                onClose={() => setModalOpen(false)}
                studentOptions={collabModalOptions}
                selectedStudentIds={collaborators}
                onSubmit={(collaborators) => {
                  const updatedCollaboratorIds = collaborators.map(
                    (c) => c.value
                  );
                  updateCollaborators(
                    updatedCollaboratorIds,
                    activityResponse.id
                  );
                  analytics?.track('collaborators updated', {
                    ...analyticsPayload,
                    number_of_collaborators: updatedCollaboratorIds.length,
                  });
                }}
              />
            </>
          )}

          <Activity
            activity={activity}
            activityResponse={activityResponse}
            readOnly
            reviewMode
          />
        </div>
      </Collapse.Body>
    </Collapse>
  );
};

StudentResponse.propTypes = {};
